const availableActionsConfig = {
  "edit": true,
  "delete": true,
  "copy": true
}

// TODO: think about adding a configuration for passing a checker callback for an action possibility — N31FuhBe
  // Specific use case: The "copy" action is only allowed for item.

export default availableActionsConfig;